import React from 'react'

export type ProductCarouselProps = React.ComponentProps<'div'>

export const ProductCarousel = (props: ProductCarouselProps) => (
  <div {...props} />
)
